// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateRangePicker_wrapper__12FjX","container":"DateRangePicker_container__2FCam"};